// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"JXf","list":"JXar","item":"JXat","dark":"JXaj9","light":"JXcz","blockHeader":"JXd1"};